import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@mui/material";
import React from "react";
import { back, bementor, eagle_icon } from "../../assets/images";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";

const BecomeMentor = () => {
  const involvedText = [
    {
      id: 1,
      text: "Live in a remote or overpopulate environment where schooling is hard to come by",
    },
    {
      id: 2,
      text: "Are otherwise unable to attend other schools because of high costs",
    },
    {
      id: 3,
      text: " Are interested in engaging with course material in a practical, discussion-based format",
    },
    {
      id: 4,
      text: "Have a desire to learn more about the world and further their relationship with Christ",
    },
  ];

  return (
    <Box sx={{ width: "100vw" }}>
      <Container
        sx={{
          height: { md: "50vh" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "center", md: "space-between" },
          alignItems: "center",
          backgroundImage: `url(${back})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          py: { xs: 5, md: 2 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            mb: { xs: 5 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            Become a Mentor
          </Typography>
          <Typography variant="h2" sx={{ width: "90%", mb: "1rem" }}>
            How to <span style={{ color: "#DB5430" }}>learn</span> and{" "}
            <span style={{ color: "#DB5430" }}>grow</span> as an{" "}
            <span style={{ color: "#DB5430" }}>EAGLE mentor</span>
          </Typography>
          <Typography>
            EAGLE mentors are much more than a teacher - they are a guide and
            coach, holistically caring for and supporting learners on their
            learning journeys. In doing this, EAGLE mentors are called to
            demonstrate Christ-like character, leadership capacity and
            whole-hearted commitment to their role and their learners. Mentors
            are not alone in their role, but collaborate with other mentors and
            receive high-quality professional development opportunities.
          </Typography>
          <CustomButton sx={{ my: "1rem" }}>
            <Typography>Join us</Typography>
            <ChevronRightRounded />
          </CustomButton>
        </Box>

        {/* Get involved Points */}
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            height: { xs: "50vh", md: "100%" },
            backgroundImage: `url(${bementor})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 5,
          }}
        />
      </Container>
    </Box>
  );
};

export default BecomeMentor;
